<template>
  <div>
    <div class="header-section">
      <div>
        <h1 class="header-style">
          Review Details
        </h1>
        <br>
        <p class="subheader-style">
          Make sure your taking the correct check-in
        </p>
      </div>
    </div>
    <br>
    <div>
      <v-card color="#F8F8F8">
        <v-card-text>
          <p class="title-text-style">
            Project: <font class="value-text-style">
              {{ selectedWorkDetails.details.project.name }}
            </font>
          </p>
          <p class="title-text-style">
            Name: <font
              v-if="selectedWorkDetails.workType === 'project-work'"
              class="value-text-style"
            >
              {{ selectedWorkDetails.details.name }}
            </font>
            <font
              v-else
              class="value-text-style"
            >
              {{ selectedWorkDetails.details.title }}
            </font>
          </p>
          <p class="title-text-style">
            Type: <font class="value-text-style">
              {{ selectedWorkDetails.workType | workTypeFormat }}
            </font>
          </p>
          <p class="title-text-style">
            High Risk Work: <font :color="getHrwColor(selectedWorkDetails.details.high_risk_work)">
              {{ selectedWorkDetails.details.high_risk_work | displayHighRisk }}
            </font>
          </p>
        </v-card-text>
      </v-card>
      <br>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="next-style"
          elevation="0"
          @click="check()"
        >
          {{ buttonName }}
        </v-btn>
        <v-btn
          class="cancel-style"
          elevation="0"
          @click="cancel()"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </div>
    <centre-spinner :loading="loading" />
    <issue-status
      v-if="showIssueStatus"
      @success="issueStatusGathered"
    />
  </div>
</template>

<script>
import moment from 'moment';
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
import IssueStatus from '../dialogs/IssueStatus.vue';
export default {
    name: 'ReviewWorkDetails',
    components: {
      'centre-spinner': spinner,
      'issue-status': IssueStatus,
    },
    filters: {
      displayHighRisk (status) {
        if (status === true) {
          return 'Yes*';
        } else {
          return 'No';
        }
      },
      workTypeFormat (val) {
        if (val === 'project-work') {
          return 'Project Work';
        } else {
          return 'Project Issue';
        }
      },
    },
    data: () => ({
      loading: false,
      checkInType: 'Worker',
      showIssueStatus: false,
    }),
    computed: {
      selectedWorkDetails () {
        return this.$store.getters['devices/getSelectedWorkDetails'];
      },
      selectedInstanceDetails () {
        return this.$store.getters['devices/getSelectedInstanceDetails'];
      },
      deviceData () {
      return this.$store.getters.getDeviceData;
    },
      checkInId () {
        return this.$store.getters['devices/getCheckInId'];
      },
      checkOutType () {
      return this.$store.getters['devices/getCheckOutType'];
      },
      appUserCheckInRecord () {
      return this.$store.getters['devices/getActiveCheckInDetails'];
    },
    messageStatus () {
      return this.checkOutType === 'cost-shift' ? 'Cost-Shift completed successfully.' : 'Check-in completed successfully.';
    },
    buttonName () {
      return this.checkOutType === 'cost-shift' ? 'Cost-Shift' : 'CheckIn';
    },
    },
    methods: {
      async checkIn () {
        this.loading = true;
        await this.$store.dispatch('devices/checkInUser', {
          orgExtId: this.deviceData.organization_id.external_id,
        details: {
          checkin_time: moment.utc().format(),
          type: 'worker',
          checkin_method_type: this.checkOutType === 'cost-shift' ? 'cost-shift' : 'manual-checkin',
          project_id: this.selectedWorkDetails.details.project.id,
          kiosk_id: this.deviceData.id,
        },
        }).then(response => {
          this.sendWorkDetails();
          this.loading = false;
        }).catch(errors => {
          this.loading = false;
        });
      },
       async sendWorkDetails () {
        if (this.selectedWorkDetails.workType === 'project-work') {
          await this.$store.dispatch('devices/sendWorkDetails', {
            details: {
              budget_id: this.selectedWorkDetails.details.id,
              budget_instance_id: this.selectedInstanceDetails,
              issue_id: null,
              type: 'project-work',
            },
            checkInId: this.checkInId.id,
          }).then(response => {
            this.loading = false;
            this.$store.dispatch('devices/clearSelectedInstanceDetails');
            this.$store.dispatch('alert/onAlert', {
              message: this.messageStatus,
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.$emit('reviewed-details');
          }).catch(() => {
            this.loading = false;
          });
        return;
        }
        await this.$store.dispatch('devices/sendWorkDetails', {
          details: {
            budget_id: null,
            budget_instance_id: null,
            issue_id: this.selectedWorkDetails.details.id,
            type: 'project-issue',
          },
          checkInId: this.checkInId.id,
        }).then(response => {
          this.loading = false;
          this.$store.dispatch('alert/onAlert', {
            message: 'Check-in completed successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.$emit('reviewed-details');
        }).catch(() => {
          this.loading = false;
        });
      },
      cancel () {
        this.loading = true;
        setTimeout(() => {
          this.$router.push({ name: 'CheckIn' });
        }, 1000);
      },
      getHrwColor (value) {
        if (value === true) return '#C62828';
        else { return '#2E7D32'; }
      },
      async check () {
     if (this.checkOutType === 'cost-shift') {
        if (this.appUserCheckInRecord.work_details.type === 'project-issue') {
        this.showIssueStatus = true;
        } else {
        this.$store.dispatch('devices/checkOutUser', {
            checkOutTime: {
              checkout_time: moment.utc().format(),
              type: 'cost-shift',
              checkout_kiosk_id: this.deviceData.id,
            },
            checkInId: this.appUserCheckInRecord.id,
          }).then(() => {
            this.$store.dispatch('devices/checkInUser', {
        orgExtId: this.deviceData.organization_id.external_id,
        details: {
          checkin_time: moment.utc().format(),
          type: 'worker',
          checkin_method_type: 'cost-shift',
          project_id: this.appUserCheckInRecord.project.id,
          kiosk_id: this.deviceData.id,
        },
        },
      ).then(() => {
        this.loading = true;
        this.sendWorkDetails();
        this.$store.dispatch('devices/workerLogout').then(() => {
          this.$store.dispatch('kioskUserLogout');
            this.$router.push({ name: 'DeviceCheckInCheckOut' });
        });
          });
        });
      }
      } else {
        await this.checkIn();
      }
      },
      async issueStatusGathered () {
        this.loading = true;
        await this.$store.dispatch('devices/checkInUser', {
        orgExtId: this.deviceData.organization_id.external_id,
        details: {
          checkin_time: moment.utc().format(),
          type: 'worker',
          checkin_method_type: 'cost-shift',
          project_id: this.appUserCheckInRecord.project.id,
          kiosk_id: this.deviceData.id,
        },
        });
        await this.sendWorkDetails();
        await this.$store.dispatch('devices/workerLogout');
        await this.$store.dispatch('kioskUserLogout');
            this.loading = false;
            this.$router.push({ name: 'DeviceCheckInCheckOut' });
      },
  },
};
</script>

<style scoped>
.header-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.short-letter-style {
  color: white;
}

.v-card {
  padding: 15px 20px;
  border-radius: 10px;
}

.type-bottom {
  margin-bottom: 0px;
}

</style>
